var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.membershipFee.attributes)?_c('div',[_c('h2',{staticClass:"m-0",domProps:{"textContent":_vm._s(_vm.membershipFee.attributes.title)}}),_vm._v(" "),(!_vm.showForm)?_c('MembershipFeeInfo',{on:{"showForm":function($event){_vm.showForm = true}}}):_c('MembershipFeeForm',{on:{"hideForm":function($event){_vm.showForm = false}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }